import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';

import { SearchMapMenuComponent } from './search-map-menu.component';
import { DrivingDirectionsComponent } from './driving-directions/driving-directions.component';
import { MapBoundariesComponent } from './map-boundaries/map-boundaries.component';
import { PropertySalesComponent } from './property-sales/property-sales.component';
import { MapTrendsComponent } from './map-trends/map-trends.component';
import { MapLayersInfoFooterComponent } from './map-layers-info-footer/map-layers-info-footer.component';
import {
  MapPointsOfInterestComponent
} from '@root/search/components/search-map-menu/map-points-of-interest/map-points-of-interest.component';
import { LocateOnMapComponent } from '@root/search/components/search-map-menu/locate-on-map/locate-on-map.component';
import { MapPremiumComponent } from '@root/search/components/search-map-menu/map-premium/map-premium.component';

@NgModule({
  declarations: [
    SearchMapMenuComponent,
    DrivingDirectionsComponent,
    MapBoundariesComponent,
    PropertySalesComponent,
    MapTrendsComponent,
    MapLayersInfoFooterComponent,
    MapPointsOfInterestComponent,
    LocateOnMapComponent,
    MapPremiumComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    SearchMapMenuComponent
  ]
})
export class SearchMapMenuModule {
}
